import { Translation } from './Translation';

export const de_DE: Translation = {
  translation: {
    placeholders: {
      notApplicable: 'Nicht anwendbar',
      placeholder: 'Platzhalter',
      dropdownDefault: 'Auswählen',
      typeToFilter: 'Eingeben zum Filtern',
      typeToSearch: 'Eingeben zum Suchen',
      textareaDefault: 'Hier eingeben',
    },
    errors: {
      textLimit:
        'Sie haben die Anzahl der zulässigen Zeichen überschritten. Bitte reduzieren Sie die Anzahl der Zeichen, um mit Ihrem Briefing fortzufahren.',
    },
    labels: {
      eLab: 'Azelis e-Lab',
      additionalInfo:
        'Anmerkungen (z. B. Benchmark, Fristen, andere Zielländer, ...)',
      price: 'z. B. 2.89–3.35 {{currency}}/{{weightUnit}}',
      targetPackaging: 'Zielverpackung',
      notes: 'Hinweise',
      attachments: 'Anhänge',
      enterAName: 'Einen Namen eingeben',
      addAttachment: 'Anhang hinzufügen',
      optional: 'Optional',
      loading: 'Laden …',
      briefing: {
        sent: 'Briefing gesendet',
        delivered: 'Briefing gesendet',
      },
      signIn: 'Anmelden',
      signOut: 'Abmelden',
      requestAccess: 'Zugang anfordern',
      multiSelectHint: 'Mehrfachauswahl möglich',
      other: 'Andere',
      noOptions: 'Keine Optionen',
      or: 'oder',
      createdAt: 'Erstellt am',
      createdBy: 'Erstellt von',
      status: 'Status',
      continue: 'Weiter',
      untitled: 'Ohne Titel',
      countries: {
        Benelux: 'Benelux',
        Belgium: 'Belgien',
        France: 'Frankreich',
        Germany: 'Deutschland',
        India: 'Indien',
        Indonesia: 'Indonesien',
        Italy: 'Italien',
        Ireland: 'Irland',
        Luxembourg: 'Luxemburg',
        Netherlands: 'Niederlande',
        'United Kingdom': 'Vereinigtes Königreich',
      },
      languages: {
        de_DE: 'Deutsch',
        en_GB: 'Englisch',
        en_US: 'Englisch',
        fr_FR: 'Französisch',
        zh_CN: 'Chinesisch',
        ko_KR: 'Koreanisch',
      },
      countrySlug: {
        BNL: 'Benelux',
        FR: 'Frankreich',
        GB: 'Vereinigtes Königreich',
        UK: 'Vereinigtes Königreich',
        DE: 'Deutschland',
        IN: 'Indien',
        IT: 'Italien',
        ID: 'Indonesien',
        IE: 'Irland',
      },
      markets: {
        AgriEnvironmental: 'Agricultural & Environmental Solutions',
        SpecialtyAgriHorti: 'Special Agricultural & Environmental Solutions',
        FoodNutrition: 'Food & Nutrition',
        FoodHealth: 'Food & Health',
        HomeCareIndustrialCleaning: 'Home Care & Industrial Cleaning',
        HomecareIndustrialCleaning: 'Home Care & Industrial Cleaning',
        PersonalCare: 'Personal Care',
      },
      ofTotal: 'von {{total}}',
      perPage: 'Pro Seite',
      briefingFlowTag: {
        base: 'base',
        colour: 'colour',
        fragrance: 'fragrance',
        formulation: 'formulation',
      },
    },
    linksOrButtons: {
      details: 'Details',
      backTo: 'Zurück zu',
      seeProjectOverview: 'Überblick über das Projekt sehen',
      backToOverview: 'Zurück zur Übersicht',
      backToReview: 'Zur Überprüfung springen',
      showMore: 'Mehr zeigen',
      goToInspiration: 'Zu den Inspirationen',
      startNewFormulation: 'Neue Formulierung starten',
      toggleMenu: 'Menü umschalten',
      navigation: {
        start: 'Formulierung beginnen',
        'project-overview': 'Meine Formulierungen',
      },
      backToStart: 'Start',
      edit: 'Bearbeiten',
      next: 'Weiter',
      prev: 'Zurück',
      sendBriefing: 'Briefing senden',
    },
    topics: {
      application: {
        name: 'Anwendungen',
        heading: {
          create: 'Was ist die Anwendung/Endnutzung des Produkts?',
          fix: 'Welche Anwendung ist die Formulierung, die Sie reparieren möchten?',
          enhance:
            'Welche Art von Anwendung hat die Formulierung, die Sie verbessern möchten?',
          modify: 'What is the product application and end use?',
        },
        levels: {
          '0': {
            normal: 'Hauptkategorie',
            selected: 'Hauptkategorie',
            other: 'Ihre Auswahl angeben',
            otherPlaceholder: 'Name der neuen Hauptkategorie',
            product: 'Product category',
          },
          '1': {
            normal: 'Eine Unterkategorie auswählen',
            selected: 'Unterkategorie',
            other: 'Ihre Auswahl angeben',
            otherPlaceholder: 'Name der neuen Unterkategorie',
            technology: 'Technology',
          },
          '2': {
            normal: 'Wählen Sie eines oder mehrere Merkmale',
            selected: 'Merkmal',
            other: 'Geben Sie Ihr Merkmal an',
            otherPlaceholder: 'Neuer Merkmalname',
            endUse: 'Finale Nutzung',
            specifyEndUse: 'Specify your end use',
            endUsePlaceholder: 'End use name',
          },
        },
      },
      'formulation-attributes': {
        name: 'Eigenschaften der Formulierung',
        heading: {
          general: 'Welche Eigenschaften soll ihr Produkt erfüllen?',
        },
        productMarketingClaims: 'Produktmarketing-Claims',
        formulationType: 'Art der Formulierung',
        texture: 'Textur',
        storage: 'Lagerung',
        productForm: 'Product Form',
        otherProductMarketingClaims:
          'Spezifizieren Sie andere Produktmarketing-Claims',
        otherFormulationType: 'Andere Formulierungsart angeben',
        otherTexture: 'Andere Textur angeben',
        otherStorage: 'Anderen Speicher angeben',
        options: {
          availableProductMarketingClaims: {
            euEcolabel: 'EU Ecolabel',
            rspoCertified: 'RSPO Certified',
            bioBasedProduct: 'Bio-based product / natural derived',
            nordicSwan: 'Nordic Swan',
            euEcocert: 'EU Ecocert',
            lowCLP: 'Low CLP (classification)',
            lowToZeroVOC: 'Low to Zero VOC',
            biodegradable: '(Readily) biodegradable',
            lowAllergens: 'Low Allergens',
            highActive: 'High Active',
            nonLabelledForCLP: 'Non-Labelled for CLP',
            mildToSkinAndEyes: 'Mild to skin and eyes',
            easyToHandle: 'Easy to handle',
            highlyEffectiveLowDosageLevels:
              'Highly effective / low dosage levels',
            preservativeFree: 'Preservative free',
            foodContact: 'Food contact',
            noAnimalTesting: 'No animal testing',
            nanoparticlesFree: 'Nanoparticles free',
            lowSVHC: 'Low SVHC',
            natural: 'Natural',
            vegan: 'Vegan',
            noHeavyMetals: 'No heavy Metals',
            soothing: 'beruhigend',
            moisturising: 'feuchtigkeitsspendend',
            sensitiveSkin: 'empfindliche Haut',
            woundProtection: 'Wundschutz',
            calming: 'lindernd',
            waterSaving: 'Einsparung von Wasser',
            antiageing: 'Anti-Aging',
            softFocus: 'weichzeichnend',
            wrinkleFilling: 'Füllung von Falten',
            antiCreasing: 'Anti-Falten',
            longLasting: 'langanhaltend',
            easyToApply: 'einfach anzuwenden',
            quickDrying: 'schnelle Trocknung',
            waterProof: 'wasserfest',
            highCoverage: 'hohe Deckkraft',
            hydrating: 'feuchtigkeitsspendend',
            oilAbsorbing: 'ölabsorbierend',
            nonBleedingFeathering: 'verläuft/verschmiert nicht',
            glossy: 'glänzend',
            kissProof: 'kussfest',
            rubResistant: 'abriebfest',
            removesWaterproof: 'entfernt wasserfest',
            gentle: 'sanft',
            wearResistant: 'verschleißfest',
            easyToRemove: 'einfach zu entfernen',
            highGlossShine: 'hoher Glanz/glänzend',
            dermatologicallyTested: 'dermatologisch getestet',
            antibacterial: 'antibakteriell',
            forSensitiveSkin: 'für empfindliche Haut',
            softening: 'Erweichung',
            detangling: 'Entwirrung',
            dryDamaged: 'trocken/beschädigt',
            fineHair: 'feines Haar',
            colourProtection: 'Farbschutz',
            colourEnhancing: 'Farbverbesserung',
            antiDandruff: 'Anti-Schuppen',
            conditioning: 'Konditionierung',
            sulphateFree: 'sulfatfrei',
            antiBuildUp: 'Anti-Ablagerungen',
            twoInOne: '2 in 1',
            permanent: 'dauerhaft',
            semiPermanent: 'semi-permanent',
            rootTouchUp: 'Wurzelauffrischung',
            temporary: 'vorübergehend',
            treatment: 'Behandlung',
            hairStrengthening: 'Stärkung der Haare',
            revitalising: 'Revitalisierung',
            exfoliating: 'Peeling',
            strengthening: 'Stärkung',
            damageRepair: 'Schadenreparatur',
            thickening: 'Verdickung',
            protection: 'Schutz',
            protecting: 'schützen',
            strongHold: 'starker Halt',
            improvedComfort: 'verbesserter Komfort',
            foodseal: 'Lebensmitteldichtung',
            gumCare: 'Zahnfleischpflege',
            whitening: 'Aufhellung',
            alcoholFree: 'alkoholfrei',
            enamelCare: 'Zahnschmelzpflege',
            sensitive: 'empfindlich',
            antiseptic: 'antiseptisch',
            antiBacterial: 'antibakteriell',
            antiAgeing: 'Anti-Aging',
            antioxidant: 'Antioxidans',
            antiPollution: 'Anti-Verschmutzung',
            repair: 'Reparatur',
            skinTightening: 'Straffung der Haut',
            illuminatingBrightning: 'Strahlen/Helligkeit',
            antiPuffinessDark: 'Anti-Schwellung/-Augenringe',
            cycles: 'Zyklen',
            purifying: 'Reinigung',
            oilControl: 'Ölkontrolle',
            cooling: 'Kühlung',
            extraFirmHold: 'extra fester Halt',
            firmHold: 'fester Halt',
            lightHold: 'leichter Halt',
            curlDefining: 'lockendefinierend',
            volumising: 'volumisierend',
            mediumHold: 'mittlerer Halt',
            flexibleHold: 'flexibler Halt',
            shine: 'Glanz',
            weatherproof: 'wetterfest',
            uvProtection: 'UV-Schutz',
            waterResistant: 'wasserbeständig',
            floral: 'floral',
            fougère: 'fougère',
            aromatic: 'aromatisch',
            woody: 'holzig',
            citrus: 'Zitrus',
            amber: 'Bernstein',
            chypre: 'Chypre',
            fruity: 'fruchtig',
            gourmand: 'gourmand',
            musk: 'Moschus',
            spicy: 'würzig',
            cleanLabel: 'Sauberes Etikett',
            naturalColours: 'Natürliche Farben',
            naturalFlavours: 'Natürliche Aromen',
            glutenFree: 'Glutenfrei',
            allergenFree: 'Allergenfrei',
            palmFree: 'Palmfrei',
            nanoFree: 'Nanofrei',
            noReducedFat: 'Kein / reduziertes Fett',
            noReducedSugar: 'Kein / reduzierter Zucker',
            noReducedSalt: 'Kein / reduziertes Salz',
            sourceHighFiber: 'Quelle von / hoch in Ballaststoffen',
            sourceHighProtein: 'Quelle von / hoch in Protein',
            sourceHighVitaminsMinerals:
              'Quelle von / reich an Vitaminen und Mineralien',
            healthBenefices: 'Gesundheitsvorteile',
            veganVegetarianAnimalFree:
              'Vegan / Vegetarisch / ohne Tierversuche',
            organic: 'Bio',
            fairTrade: 'Fair-Trade',
            halal: 'Halal',
            kosher: 'Koscher',
            sweatReduction: 'Schweißreduzierung',
            odourProtection: 'Geruchsschutz',
            aluminiumFree: 'Aluminium-frei',
            noWhitening: 'Kein Weißeln',
            invisible: 'Unsichtbar',
            refreshing: 'Erfrischend',
            moisturizing: 'Feuchthaltend',
          },
          availableFormulationTypes: {
            owEmulsion: 'O/W-Emulsion',
            woEmulsion: 'W/O-Emulsion',
            waterBased: 'Auf Wasserbasis',
            oilBased: 'Auf Ölbasis',
            emulsion: 'Emulsion',
            anhydrous: 'wasserfrei',
            alcoholic: 'Alkoholisch',
            nonAlcoholic: 'nicht alkoholisch',
            other: 'Andere',
            solidStick: 'Fester Stift',
            gelStick: 'Gel-Stift',
            aerosolSpray: 'Aerosol Spray',
            nonAerosolSpray: 'Non Aerosol Spray',
            cream: 'Creme',
            rollOn: 'Roll On',
            powder: 'Pulver',
          },
          availableTextures: {
            fluid: 'Flüssigkeit',
            spray: 'Spray',
            serum: 'Serum',
            aerosol: 'Aerosol',
            gel: 'Gel',
            lotion: 'Lotion',
            cream: 'Creme',
            solid: 'Fest',
            foam: 'Schaum',
            powder: 'Puder',
            liquid: 'Flüssigkeit',
            tablet: 'Tablette',
            stick: 'Stift',
            bar: 'Riegel',
            nonAerosol: 'Kein Aerosol',
            other: 'Andere',
            soft: 'Weich/soft',
            emulsion: 'Emulsion',
          },
          availableStorage: {
            ambient: 'Umgebung',
            bakeryDryBlend: 'Bäckereimischung / Trockenmischung',
            instantDryBlend: 'Instant (Trockenmischung)',
            frozen: 'Gefroren',
            bestBefore: 'Mindesthaltbarkeitsdatum',
            pasteurisation: 'Pasteurisierung',
            chilled: 'Gekühlt',
            bakeStability: 'Stabilität des Backens (Mikrowelle)',
          },
          availableProductForm: {
            powder: 'Powder',
            liquid: 'Liquid',
            granules: 'Granules',
            flakes: 'Flakes',
            paste: 'Paste',
            wax: 'Wax',
            prills: 'Prills',
            needles: 'Needles',
            piece: 'Piece',
            emulsion: 'Emulsion',
          },
        },
        errors: {
          productMarketingClaims: 'Fehler beim Laden von Marketing-Claims',
        },
      },
      fragrance: {
        name: 'Fragrance',
        heading: {
          general: 'Fragrance your formulation',
        },
        fragranceFormulation:
          'Do you want to have your formulation fragranced?',
        attributesFulfill: 'Which attributes should your fragrance fulfill?',
        requirements:
          'Are there any requirements that the fragrance needs to comply to?',
        colourOrConcept: 'Concept / Colour',
        CMR: 'CMR (Carcinogenic, mutagenic and reprotoxic)',
        direction: 'Fragrance direction',
        mustComply: 'Fragrance must comply to',
        maxAllergensOnLabel: 'Max amount allergens on label',
        requestedApplicationDosage: 'Requested application dosage (in %)',
        fragranceSamples: 'Need for fragrance samples?',
        requiredSampleTime: {
          heading: 'What is the required timing you need the sample by?',
          label: 'Required sample time',
        },
        largerFragranceSize: {
          heading:
            'Please specify if you need a larger fragrance sample size than 10gr per sample.',
          label: 'Larger sample size',
        },
        specifyFragranceMustOther: 'Specify other',
        options: {
          confirmFragranceOptions: {
            yes: 'Yes',
            no: 'No',
          },
          availableColoursOrConcepts: {
            black: 'Black',
            silver: 'Silver',
            white: 'White',
            blue: 'Blue',
            yellow: 'Yellow',
            pink: 'Pink',
            purple: 'Purple',
            green: 'Green',
            orange: 'Orange',
            gold: 'Gold',
            natural: 'Natural',
            clean: 'Clean',
            care: 'Care',
            hygiene: 'Hygiene',
            malodour: 'Malodour',
            performance: 'Performance',
            premium: 'Premium',
          },
          availableDirection: {
            citrus: 'Citrus',
            chypre: 'Chypre',
            floral: 'Floral',
            floriental: 'Floriental',
            fruity: 'Fruity',
            gourmand: 'Gourmand',
            green: 'Green',
            herbal: 'Herbal',
            lavender: 'Lavender',
            musk: 'Musk',
            oriental: 'Oriental',
            pine: 'Pine',
            spicy: 'Spicy',
            woody: 'Woody',
          },
          availableCMR: {
            notAllowed: 'Not allowed',
            allowedButOilNotLabelled: 'Allowed but oil not labelled CMR',
            allowed: 'Allowed',
          },
          mustComply: {
            noAllergensOnOil: 'No allergens on oil',
            noAllergensOnFinalProduct: 'No allergens on final product',
            pCMNMFree: 'PCM/NM free',
            ecoLabel: 'Ecolabel',
            okotestCandidate: 'Okotest candidate',
            vegan: 'Vegan',
            other: 'Other',
          },
        },
      },
      'processing-capabilities': {
        name: 'Verarbeitungsfähigkeiten',
        heading: {
          general: 'Was sind die Verarbeitungsfähigkeiten Ihres Produkts?',
        },
        bakeStability: 'Stabilität beim Backen',
        bakingTime: 'Backzeit (Minuten)',
        bakingTemperature: 'Backtemperatur (°C)',
        fillingTime: 'Füllzeit (Minuten)',
        fillingTemperature: 'Fülltemperatur (°C)',
        mixingStepDetails:
          'Details der Mischschritte (hohe Scher-/Paddelrührer)',
        productPh: 'Produkt-pH',
        brix: 'Brix (lösliche Feststoffe)',
        processingCapabilitiesPackagingDetails:
          'Art und Details zur Verpackung',
        foodSafetyDetails: 'Lebensmittelsicherheit (Pasteurisierung/UHT)',
        processingHotCold: 'Verarbeitung kalt/warm',
        homogenisation: 'Homogenisierung',
        otherProcessingCapabilities: 'Andere Verarbeitungsfähigkeiten',
      },
      restrictions: {
        name: 'Einschränkungen',
        heading: {
          general:
            'Gibt es irgendwelche Einschränkungen, die die Formulierung erfüllen muss?',
        },
        requirements: 'Anforderungen',
        restrictions: 'Einschränkungen',
        can: 'Kann',
        must: 'Muss',
        mustComply: 'Formulierung muss entsprechen',
        canComply: 'Formulierung kann entsprechen',
        requirementsMust: 'Anforderungen – Muss',
        requirementsCan: 'Anforderungen – Kann',
        restrictionsMust: 'Einschränkungen – Muss',
        restrictionsCan: 'Einschränkungen – Kann',
        specifyRequirements: 'Anforderungen angeben',
        specifyRestrictions: 'Einschränkungen angeben',
        options: {
          silictions: 'keine Silikone',
          parabens: 'keine Parabene',
          oil: 'keine Inhaltsstoffe auf Mineralölbasis',
          emulsifier: 'Emulgatorfrei',
          preservatives: 'keine Konservierungsstoffe',
          ethanol: 'Ethanolfrei',
          cold: 'Kalte Produktion',
          polymore: 'frei von synthetischem Polymer',
          uv: 'keine organischen UV-Filter',
          nanomaterial: 'kein Nanomaterial',
          sulfate: 'Sulfatfrei',
          surfactant: 'wenig Tenside',
          tears: 'Tränenfreie Formulierung',
          talc: 'Talkumfrei',
          notApplicable: 'Nicht anwendbar',
          other: 'Andere',
        },
        errors: {
          restrictions: 'Fehler beim Laden von Einschränkungen',
        },
      },
      requirements: {
        name: 'Requirements',
        heading: {
          general:
            'Are there any requirements that the formulation needs to comply to?',
          specify: 'Please specify your further formulation requirements',
        },
        requirements: 'Requirements',
        can: 'Can',
        must: 'Must',
        mustComply: 'Formulation must comply to',
        canComply: 'Formulation can comply to',
        requirementsMust: 'Requirements - Must',
        requirementsCan: 'Requirements - Can',
        specifyRequirements: 'Specify requirements',
        applicationConditionDetails: {
          heading:
            'Please indicate details on the application conditions (Type of surface or soil, temperature range …).',
          label: 'Application condition details',
        },
        pHRange: {
          heading: 'In which pH range the product needs to be active?',
          label: 'phRange',
        },
        aggressiveComponents: {
          heading:
            'Please list the potential aggressive components in the formulation.',
          label: 'Aggressive components',
        },
        lightStability: {
          heading: 'Is light stability important?',
          label: 'Light stability',
          answer: {
            yes: 'Yes',
            no: 'No',
          },
        },
        options: {
          biodegradable: '(Readily) biodegradable',
          bioBased: 'Bio-based product / natural derived',
          carBody: 'Car body shop compliant',
          coldPress: 'Cold process',
          easyToHandle: 'Easy to handle',
          euEcocert: 'EU Ecocert',
          euEcolabel: 'EU Ecolabel',
          foodContact: 'Food contact',
          halal: 'Halal',
          highActive: 'High active',
          highlyEffectiveLowDosageLevels:
            'Highly effective / low dosage levels',
          kosher: 'Kosher',
          lowAllergens: 'Low Allergens',
          lowCLP: 'Low CLP (classification)',
          lowSVHC: 'Low SVHC',
          lowToZeroVOC: 'Low to Zero VOC',
          mildToSkinAndEyes: 'Mild to skin and eyes',
          nanoparticlesFree: 'Nanoparticles free',
          natural: 'Natural',
          noAnimalTesting: 'No animal testing',
          noHeavyMetals: 'No heavy metals',
          nonLabelledForCLP: 'Non-Labelled for CLP',
          nordicSwan: 'Nordic Swan',
          palmFree: 'Palm free',
          phosphorFree: 'Phosphor free',
          preservativeFree: 'Preservative free',
          rspoCertified: 'RSPO Certified',
          vegan: 'Vegan',
          notApplicable: 'Not applicable',
          other: 'Other',
        },
        errors: {
          requirements: 'Error loading requirements',
        },
      },
      colour: {
        name: 'Colour',
        heading: {
          general: 'Colour your formulation',
        },
        formulationColoured: 'Do you want to have your formulation coloured?',
        colourAttributes: 'Which attributes should your colourant fulfill?',
        colourShades: 'Colour Shades',
        colourSamples: {
          label: 'Colour samples',
          heading: 'Is there a need for colour samples?',
        },
        requiredTime: {
          heading: 'What is the required timing you need the sample by?',
          label: 'Required sample time',
        },
        labSupport: {
          heading: 'Do you require support from the Miliken lab? ',
          label: 'Support from the supplier lab required?',
        },
        options: {
          confirmColourOptions: {
            yes: 'Yes',
            no: 'No',
          },
          shades: {
            cyanBlue: 'Cyan Blue',
            royalBlue: 'Royal Blue',
            darkBlue: 'Dark Blue',
            brightBlue: 'Bright Blue',
            aquamarineBlue: 'Aquamarine Blue',
            brightGreen: 'Bright Green',
            green: 'Green',
            brightYellow: 'Bright Yellow',
            lemonYellow: 'Lemon Yellow',
            darkYellow: 'Dark Yellow',
            yellow: 'Yellow',
            orange: 'Orange',
            fluorescentYellow: 'Fluorescent Yellow',
            brightViolet: 'Bright Violet',
            purple: 'Purple',
            darkViolet: 'Dark Violet',
            darkRed: 'Dark red',
            fluorescentPink: 'Fluorescent Pink',
            brightPink: 'Bright Pink',
            softPink: 'Soft Pink',
          },
        },
      },
      'target-consumer': {
        name: 'Zielverbraucher',
        heading: {
          general: 'Wer ist Ihr Zielverbraucher?',
        },
        age: 'Alter',
        targetConsumerAge: 'Alter des Zielverbrauchers',
        gender: 'Geschlecht',
        targetConsumerGender: 'Geschlecht des Zielverbrauchers',
        buttons: {
          genders: {
            female: 'Weiblich',
            male: 'Männlich',
            allGenders: 'Alle Geschlechter',
          },
          allAges: 'Alle Altersgruppen',
        },
      },
      'additional-info': {
        name: 'Zusätzliche Informationen',
        heading: {
          general: 'Haben Sie noch etwas hinzuzufügen?',
        },
        additionalInfo: 'Zusätzliche Informationen',
        additionalInfoFiles: 'Zusätzliche Informationsdateien',
      },
      price: {
        name: 'Preis',
        heading: {
          general: 'Was sind Ihre geschätzten Kosten für die Formulierung?',
          base: 'Was sind Ihre geschätzten Kosten für die Basis-Formulierung',
          color: 'Was sind Ihre geschätzten Kosten für die Farbe?',
          fragrance: 'Was sind Ihre geschätzten Kosten für die Düfte?',
        },
      },
      'product-details': {
        name: 'Product Details',
        heading: {
          general: 'Please specify your product details.',
        },
        finishedProductSamples: {
          heading: 'Need for finished product samples?',
          answer: {
            yes: 'Yes',
            no: 'No',
          },
          requiredTimeForSample: 'What is the required time for the sample?',
        },
        finishedProductPotential:
          'What is the finished product potential? (t/year)',
        projectDeadline: 'Project deadline',
      },
      packaging: {
        name: 'Verpackung',
        heading: {
          general: 'Was ist Ihre Zielverpackung?',
        },
        options: {
          pumpDispenser: 'Pumpspender',
          sprayDispenser: 'Sprühspender',
          jar: 'Tiegel',
          tube: 'Tube',
          aerosol: 'Aerosol',
          sachet: 'Sachet',
          bagInCan: 'Beutel-in-Dose',
          airPump: 'Luftpumpe',
          bag: 'Tasche',
          carton: 'Karton',
          bottle: 'Flasche',
          compact: 'Kompakt',
          jarBottle: 'Glas-Flasche',
          other: 'Andere',
        },
      },
      'modification-type': {
        name: 'Modification Type',
        heading: {
          general: 'Which parts of your formulation do you want to modify?',
          type: 'Modification type',
        },
        options: {
          base: 'Modify base formulation',
          colour: 'Modify colour',
          fragrance: 'Modify fragrance',
        },
      },
      'modification-issue': {
        name: 'Modification',
        heading: {
          general: 'What is the modification you want to make?',
        },
        explainIssue: 'Please explain your issue',
      },
      problem: {
        name: 'Problem',
        fix: {
          name: 'Herausforderung',
        },
        enhance: { name: 'Verbesserung' },
        heading: {
          fix: 'Was ist die Herausforderung, der Sie bei Ihrer Formulierung gegenüberstehen?',
          enhance:
            'Welche Verbesserung möchten Sie an Ihrer Formulierung vornehmen?',
        },
      },
      ingredients: {
        name: 'Inhaltsstoffe',
        heading: {
          general:
            'Welche Inhaltsstoffe verwenden Sie derzeit in der Formulierung?',
        },
        azelisRawMaterials: 'Azelis Rohstoffe',
        rawMaterials: 'Rohstoffe',
        rawMaterial: 'Rohstoff',
        rawMaterialFiles: 'Dateien zu Rohstoffen',
        ingredientsFiles: 'Dateien zu Inhaltsstoffen',
        upload:
          'Laden Sie Ihre Formulierung hier, hoch oder fügen Sie unten Rohstoffe hinzu.',
        other: 'Rohstoffe (z. B. Wasser, Kieselsäure, Caprylylglykol, ...)',
      },
      'active-ingredients': {
        name: 'Active ingredients',
        heading: {
          general: 'What is the active ingredient of the formulation?',
        },
        chooseActiveIngredient: 'Choose active ingredient',
        concentration: 'Konzentration [g/L]',
        addAnother: 'Add another active ingredient',
      },
      'active-function': {
        name: 'Active function',
        heading: {
          general:
            'Do you want to add further ingredients to your formulation?',
          review: 'Function',
        },
        adjuvant: {
          name: 'Adjuvant',
          choose: 'Choose adjuvant',
        },
        stabilizer: {
          name: 'Stabilizer',
          choose: 'Choose stabilizer',
        },
        emulsifier: {
          name: 'Emulsifier',
          choose: 'Choose emulsifier',
        },
        liquidColorant: {
          name: 'Liquid colorant',
          choose: 'Choose liquid colorant',
        },
        solvent: {
          name: 'Solvent',
          choose: 'Choose solvent',
        },
      },
      formulations: {
        name: 'Formulierungen',
      },
      review: {
        name: 'Überprüfung',
      },
    },
    modals: {
      cancelBriefing: {
        prompt: 'Möchten Sie das Briefing abbrechen?',
        content: 'Alle vorhandenen Eingaben gehen verloren.',
        confirm: 'Ja',
        cancel: 'Nein',
      },
      customerSelection: {
        prompt: 'Benutzer angeben',
        content:
          'Bitte wählen Sie den Kunden und den Kundenbenutzer aus, für den Sie formulieren',
        form: {
          customer: 'Kunde',
          customerUser: 'Benutzer des Kunden',
        },
        confirm: 'Bestätigen',
        cancel: 'Abbrechen',
        footer:
          'Wenn Sie das Azelis e-Lab verlassen möchten, können Sie sich <link1 label="hier abmelden" /> oder das <link2 label="Azelis Kundenportal" /> besuchen',
        error: {
          heading: 'Etwas ist schief gelaufen',
          messages: {
            loadingCustomer: 'Das Laden der Kundendaten ist fehlgeschlagen.',
            loadingCustomerUser: 'Das Laden der Nutzer ist fehlgeschlagen.',
            settingCustomerUser:
              'Es gab ein Problem beim Laden des Nutzerprofils.',
          },
          content:
            'Bitte probieren Sie es noch einmal. Falls das Problem weiterhin besteht, loggen Sie sich bitte aus und wieder ein, oder <link1 label="kontaktieren Sie den Azelis Support" />.',
          confirm: 'Erneut versuchen',
          cancel: 'Abmelden und erneut versuchen',
          cannotSelectEmployeeUsers:
            'Es ist nicht möglich Mitarbeiter Accounts auszuwählen',
        },
      },
      changeCustomerSelection: {
        change: 'Ändern',
        prompt: 'Möchten Sie den Benutzer, als den Sie handeln, ändern?',
        confirm: 'Ja, ändern',
        cancel: 'Weiter',
      },
      deleteUploadedFile: {
        prompt: 'Möchten Sie die Datei löschen?',
        confirm: 'Ja, löschen',
        cancel: 'Abbrechen',
      },
    },
    components: {
      briefingSelection: {
        heading: 'Wie wollen Sie anfangen?',
        buttons: {
          create: {
            title: 'Erstellen',
            copy: 'einer neuen Formulierung',
          },
          enhance: {
            title: 'Verbessern',
            copy: 'einer bestehenden Formulierung',
          },
          modify: {
            title: 'Modify',
            copy: 'an existing formulation',
          },
          fix: {
            title: 'Beheben',
            copy: 'eines Problems mit einer bestehenden Formulierung',
          },
        },
        inspirationLink:
          'Lassen Sie sich von bestehenden Formulierungen inspirieren',
        loading: 'Bitte warten Sie, während wir die erforderlichen Daten laden',
      },
      stepPackaging: {
        packagingSamplePrompt:
          'Wenn Sie Ihre Verpackung zur Verfügung haben, senden Sie sie uns bitte zu, damit wir die Formulierung nach Ihren Bedürfnissen optimieren können. Bitte geben Sie Ihren Namen und den Namen des Projekts an, damit wir es Ihrem Briefing zuordnen können.',
        addressLabel: 'Adresse',
        otherPackaging: 'Andere Verpackung angeben',
      },
      review: {
        heading: 'Überprüfung',
        productName: 'Name meines Projekts',
      },
      success: {
        heading: 'Vielen Dank! \n Anfrage erfolgreich gesendet.',
        emailInfo:
          'Eine Zusammenfassung wurde an Ihre E-Mail-Adresse gesendet.',
        whatsNext: {
          heading: 'Was kommt als Nächstes?',
          review: 'Ihr Briefing wird von unserem Experten überprüft.',
          contact:
            'Ihr Kundenbetreuer wird sich in Kürze mit Ihnen in Verbindung setzen.',
        },
        recommendations: {
          heading: 'Brauchen Sie mehr Inspiration?',
          subheading:
            'Hier sind ein paar weitere Formulierungen und Inhaltsstoffe, die zu Ihrer Anwendung passen:',
          noDescription: 'Keine Beschreibung',
        },
      },
      projectOverview: {
        heading: 'Formulierungs Übersicht',
        emptyFormulations:
          'Es scheint, dass Sie noch keine Formulierungen haben.',
        createFormulation: 'Formulierung erstellen',
        myFormulations: 'Meine Formulierungen',
        teamFormulations: '{{team}} Formulierungen',
        team: 'Team',
        filter: {
          country: 'Nach Land filtern',
          market: 'Nach Markt filtern',
          application: 'Nach Anwendung filtern',
        },
        resetAllFilters: 'Alle Filter löschen',
      },
      projectDetails: {
        projectType: {
          heading: 'Projekttyp',
          create: 'Neue Formulierung erstellen',
          enhance: 'Verbessern einer bestehenden Formulierung',
          fix: 'Beheben eines Problems mit einer bestehenden Formulierung',
        },
        referenceId: 'Referenz-ID',
        formulationSpecifics: 'Formulierung angeben',
        fileDownloadHelp:
          'Wenn die Datei in einer neuen Registerkarte geöffnet wird, verwenden Sie strg + s (auf Windows) oder cmd + s (auf Mac), um die Datei zu speichern',
      },
      account: {
        heading: 'Ihr Konto',
        name: 'Name',
        email: 'E-Mail-Adresse',
        selectedMarket: 'Ausgewählter Markt',
      },
      fileUpload: {
        fileListLabel: 'Dateien angehängt',
        privacy:
          'Ihre Daten-Uploads sind absolut sicher und werden nicht an Dritte weitergegeben. Sie werden von nur Azelis im Projektkontext verwendet, um die besten Ergebnisse für Sie zu gewährleisten.',
      },
      customerSelectionBar: {
        onBehalf: 'Sie formulieren im Namen von:',
      },
      intro: {
        heading: {
          main: 'Einfacher Zugang zu all unserer technischen Expertise mit dem neuen Azelis e-Lab.',
          about: 'Über das e-Lab',
        },
        content: {
          main: 'Das neue e-Lab von Azelis ist der intelligenteste Weg, um neue Formulierungen, zu erstellen oder bestehende zu verbessern. Treten Sie direkt mit unseren Experten in Kontakt und verkürzen Sie Ihren Go-to-Market-Prozess!',
          benefits: [
            'Eine bestehende Formulierung verbessern',
            'Neue innovative Formulierungen erstellen',
            'Treten Sie in direkten Kontakt mit technischen Experten von Azelis',
            'Rund um die Uhr verfügbar',
            'Jetzt loslegen!',
          ],
        },
      },
      signIn: {
        passwordLabel: 'Passwort',
        email: 'E-Mail-Adresse',
        signUp: 'Sie haben kein Konto? $t(labels:requestAccess)!',
        loginWithCustomerPortal: 'Mit Kundenportal anmelden',
        pleaseWait: 'Bitte warten Sie, während wir Sie anmelden.',
        errors: {
          errorEmpty:
            'Bitte geben Sie eine E-Mail-Adresse und ein Passwort ein',
          errorIncorrect:
            'Die Kombination aus eingegebener E-Mail und Passwort ist falsch.',
          errorServerside:
            'Ein Fehler ist aufgetreten, bitte versuchen Sie es später noch einmal …',
          errorCustomerPortalLogin:
            'Wir konnten nicht auf Ihr Profil im Kundenportal zugreifen.',
          access_denied:
            'Es scheint, als ob die Berechtigung verweigert wurde. Bitte versuchen Sie es erneut.',
        },
      },
      footer: {
        partOfAzelis: 'Teil des Azelis Kundenportals',
        copyright: 'Copyright © Azelis {{year}}. Alle Rechte vorbehalten.',
        links: {
          cookie: 'Cookie-Richtlinie',
          privacy: 'Datenschutzerklärung',
          terms: 'Nutzungsbedingungen',
        },
      },
      countryMarketSelector: {
        reason: {
          empty: {
            heading: 'Kein Land oder Markt ausgewählt',
            body: 'Sie haben noch kein Land oder keinen Markt ausgewählt. Bitte wählen Sie eine der verfügbaren Optionen unten aus:',
            universalCustomer: {
              heading: 'Kein Unternehmen, Land oder Markt ausgewählt',
              body: 'Sie haben noch kein Unternehmen, Land oder Markt ausgewählt. Bitte wählen Sie eine der verfügbaren Optionen unten aus:',
            },
          },
          invalid: {
            heading: 'Ungültiges Land oder Markt ausgewählt',
            body: 'Ihr ausgewähltes Land oder Ihr ausgewählter Markt ist ungültig. Bitte wählen Sie eine der verfügbaren Optionen unten aus:',
            universalCustomer: {
              heading: 'Ungültige Auswahl',
              body: 'Ihr ausgewähltes Unternehmen, Land oder Ihr ausgewählter Markt ist ungültig. Bitte wählen Sie eine der verfügbaren Optionen unten aus:',
            },
          },
          preferences: {
            heading: 'Einstellungen',
            body: 'Bitte bedenken Sie, dass eine Änderung Ihrer Einstellungen Auswirkungen auf die Inhalte hat, die Ihnen zur Verfügung stehen.',
          },
        },
        customer: 'Unternehmen',
        country: 'Land',
        market: 'Markt',
        preferredLanguage: 'Bevorzugte Sprache',
        confirm: 'Ändern',
        cancel: 'Abbrechen',
      },
      error404: {
        heading: 'Seite nicht gefunden',
        body: 'Wir konnten bei dieser URL nichts finden. Versuchen Sie, mithilfe des Menüs zu navigieren oder überprüfen Sie Ihren Link erneut.',
      },
      noCountryMarketAvailable: {
        heading: 'Kein gültiges Land oder Markt gefunden',
        body: 'Ihr Benutzerprofil scheint nicht mit einem Land/Marktsegmenten verknüpft zu sein, die von e-Lab unterstützt werden. Bitte wenden Sie sich an den Systemadministrator.',
      },
      filters: {
        filter: 'Filter',
      },
    },
    emails: {
      customer: {
        subject: 'Azelis e-Lab Formulierungs-Briefing erhalten',
        html: {
          introNotCreatedByEmployee:
            'Vielen Dank! Ihr Briefing an {{branch}} {{branchFormulationPrefix}} wurde erfolgreich an die Azelis technischen Experten gesendet.',
          introCreatedByEmployee:
            '{{employeeCreatorName}} hat in Ihrem Auftrag ein Briefing für {{branch}} {{branchFormulationPrefix}} erstellt. Es wurde erfolgreich an die Azelis technischen Experten geschickt.',
          newFormulationPrefix: 'einer neuen Formulierung',
          existingFormulationPrefix: 'einer bestehenden Formulierung',
          heading: 'Ein neues Briefing wurde im e-Lab erstellt',
          line1: 'Sehr geehrte(r) {{customerName}},',
          line2:
            'Unser Expertenteam wird Ihr Briefing jetzt überprüfen und sich bald mit Ihnen in Verbindung setzen.',
          line3:
            'Nachfolgend, finden Sie eine Zusammenfassung der Informationen, die uns zur Verfügung gestellt wurden.',
          referenceId: 'Referenz-ID',
          projectName: 'Name des Projekts',
          marketSegment: 'Marktsegment',
          country: 'Land',
          thankYou: 'Vielen Dank, dass Sie das Azelis e-Lab verwenden.',
          inspirationLinkText: 'Inspiration',
          inspirationSuggestion:
            'Wenn Sie die neuesten Trends in Ihrer Branche und neue Markteinblicke von unseren Azelis Experten nicht verpassen möchten, besuchen Sie bitte unseren Bereich {{- inspirationLink}}.',
          theAzelisTeam: 'Das Azelis Team',
          copyright: 'Copyright © Azelis {{date}}. Alle Rechte vorbehalten.',
        },
      },
      lab: {
        subject: 'Azelis e-Lab Formulierungs-Briefing von {{byDisplayName}}',
        byFor: '{{byMe}} für {{forMe}}',
        html: {
          line1:
            'Ein neues Briefing für {{branch}} {{branchFormulationPrefix}} wurde von {{byDisplayName}} im Azelis e-Lab veröffentlicht.',
          referenceId: 'Referenz-ID:',
          createdAt: 'Erstellt am:',
          projectName: 'Name des Projekts:',
          pleaseContact:
            'Bitte wenden Sie sich an {{- mailToLink}}, um weitere Details zu besprechen.',
          unnamedProject: 'Unbenanntes Projekt',
          yourAzelisTeam: 'Ihr Azelis e-Lab Team',
        },
      },
      auxiliary: {
        branch: {
          create: 'das Erstellen',
          enhance: 'das Beheben',
          modify: 'modify',
          fix: 'das Erweitern',
        },
      },
    },
  },
};
